import {get as getCookie} from "js-cookie";

const userProfileCookieName = "reece-user-profile"
const customerNumber = "reece-account-number"

export const getCookieUserId = () => {
    const userProfile = getCookie(userProfileCookieName)

    if (userProfile) {
        const parsedUserProfile = JSON.parse(userProfile)
        return parsedUserProfile && parsedUserProfile.id
    }
    return null
}

export const getCookieCustomerNumber = () => {
    return getCookie(customerNumber)
}



// WEBPACK FOOTER //
// ./javascript/product-search-page/utils/cookieUtils.js